module.exports = __webpack_public_path__ + "media/images/games/memory_game/meemo/fronts/m6-a9418b6ed97ac0deaf17ae5bf73b1e5e.png";